// in src/users.js
import React from "react";
import { styled } from "@mui/material/styles";
import {
  Create as BaseCreate,
  ImageField,
  SimpleForm,
  SelectInput,
  TextInput,
  ImageInput,
  NumberInput,
  required,
  BooleanInput,
  FormDataConsumer,
  useGetOne,
  useDataProvider,
  useNotify,
  useRedirect,
} from "react-admin";
import { SelectInputCategory } from "../Category/SelectInput";
import { useProvider } from "../ProviderContext";
import { useTourContext } from "../contexts/TourContext";
import useTour from "../hooks/useTour";
import { tourConfigs } from "../config/tourConfigs";
import { updateOnboardingStep } from "../components/dataProvider";
import { useContext } from "react";
import { OnboardingContext } from "../contexts/OnboardingContext";
const PREFIX = "BooleanInputs";

const classes = {
  inlineBlock: `${PREFIX}-inlineBlock`,
};

const StyledBaseCreate = styled(BaseCreate)({
  [`& .${classes.inlineBlock}`]: {
    display: "inline-flex",
    marginRight: "1rem",
  },
});

export const BooleanInputs = () => {
  // const { watch, setValue } = useFormContext();
  // const qrEnabled = watch("qrEnabled");
  // const cardPaymentEnabled = watch("cardPaymentEnabled");

  // useEffect(() => {
  //   if (qrEnabled) {
  //     setValue("cardPaymentEnabled", false);
  //   }
  //   if (cardPaymentEnabled) {
  //     setValue("qrEnabled", false);
  //   }
  // }, [qrEnabled, cardPaymentEnabled, setValue]);

  return (
    // <FormDataConsumer>
    //   {({ formData, ...rest }) => (
    <>
      <BooleanInput validate={[required()]} source="variablePrice" label="Precio Variable" defaultValue={false} />
      <BooleanInput
        validate={[required()]}
        source="qrEnabled"
        label="Pago con QR habilitado"
        // disabled={cardPaymentEnabled}
        defaultValue={false}
      />
      <BooleanInput
        validate={[required()]}
        source="cardPaymentEnabled"
        label="Pago con Tarjeta / Tigo Money habilitado"
        // disabled={qrEnabled}
        defaultValue={false}
      />
    </>
    //   )}
    // </FormDataConsumer>
  );
};

export const PinnedInputs = () => {
  return (
    <FormDataConsumer>
      {({ formData }) => (
        <>
          <BooleanInput source="pinned.isPinned" label="Fijar servicio" defaultValue={false} />
          {formData.pinned && formData.pinned.isPinned && (
            <TextInput source="pinned.tag" label="Etiqueta del Servicio Destacado" />
          )}
          <BooleanInput source="package.isEnabled" label="Habilitar paquetes" defaultValue={false} />
          {formData.package && formData.package.isEnabled && (
            <TextInput source="package.quantity" label="Cantidad" validate={[required("Cantidad es requerido")]} />
          )}
        </>
      )}
    </FormDataConsumer>
  );
};

export const Create = ({ ...props }) => {
  // ...existing code...
  const { isActiveManual, setManualActive, isStep3Active } = useTourContext();
  const tour = useTour();
  React.useEffect(() => {
    // Solo iniciar el tour si ambas variables están activas
    if (isActiveManual && isStep3Active) {
      tour.startPageTour(
        "first-service",
        tourConfigs["first-service"].steps,
        () => setManualActive(false) // Se ejecuta cuando el tour se cierra
      );
    }
  }, [isActiveManual, isStep3Active, setManualActive, tour]);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;
  const { data: provider } = useGetOne("providers", { id: providerId });
  const { provider: providerContext } = useProvider();
  const intervalMinutes = providerContext?.intervalMinutes || 30;
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  // const { setOnboardingSteps } = useContext(OnboardingContext);
  const { setOnboardingSteps, onboardingSteps, checkAndTriggerOnboarding } = useContext(OnboardingContext);

  // Generar choices dinámicamente según intervalMinutes
  const maxMinutes = 8 * 60; // 8 horas máximo
  const choices = Array.from({ length: Math.floor(maxMinutes / intervalMinutes) + 1 }, (_, i) => {
    const value = i * intervalMinutes;
    let name;
    if (value === 0) {
      name = "0 Minutos";
    } else if (value < 60) {
      name = `${value} Minutos`;
    } else if (value % 60 === 0) {
      name = `${value / 60} Hora${value === 60 ? "" : "s"}`;
    } else {
      name = `${Math.floor(value / 60)} Hora${Math.floor(value / 60) > 1 ? "s" : ""} ${value % 60} Minutos`;
    }
    return { id: value, name };
  });
  const handleSave = async (values) => {
    try {
      // Primero crea el servicio
      await dataProvider.create("service", { data: values });

      // Luego actualiza el onboarding step 3
      const profile = JSON.parse(localStorage.getItem("profile") || "{}");
      const userId = profile?._id;
      await updateOnboardingStep(
        { userId: userId, step: 3 },
        { setOnboardingSteps, checkAndTriggerOnboarding, onboardingSteps }
      );

      // Mostrar notificación de éxito
      notify("Servicio creado exitosamente", { type: "success" });

      // Redireccionar al listado de servicios
      redirect("/service");
    } catch (err) {
      // El error puede venir como string directo desde el dataProvider o como objeto
      let errorMessage = "";

      if (typeof err === "string") {
        errorMessage = err;
      } else {
        errorMessage = err?.message || err?.body?.error || err?.error || "";
      }

      if (err?.status && err.status >= 400) {
        // Errores del servidor con status HTTP
        const serverErrorMessage = err?.body?.error || err?.message || err?.error || "Error al crear el servicio";
        notify(`Error: ${serverErrorMessage}`, { type: "error" });
      } else if (errorMessage) {
        // Error con mensaje específico
        notify(`Error: ${errorMessage}`, { type: "error" });
      } else {
        // Error genérico
        notify("Error al crear el servicio", { type: "error" });
      }
    }
  };
  return (
    <>
      <StyledBaseCreate {...props}>
        <SimpleForm onSubmit={handleSave} data-cy="service-create-form">
          <div style={{ display: "flex", flexDirection: "column" }} data-tour="form-bloque1">
            <TextInput validate={[required("El nombre es requerido")]} source="name" label="Nombre del Servicio" />
            <ImageInput
              // validate={[required("La imagen es requerida")]}
              source="imageURL"
              label="Imagen de Servicio"
              accept=".jpeg,.jpg,.png,.jfif"
              placeholder={<p>Arrastra tu imagen o haz clic aquí.</p>}
            >
              <ImageField source="src" title="Imagen" />
            </ImageInput>
            <TextInput
              validate={[required("La descripción es requerida")]}
              multiline
              source="description"
              label="Descripción."
            />
            <NumberInput
              validate={[required("El precio es requerido")]}
              source="unitPrice"
              placeholder="Bs."
              label="Precio Unitario"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }} data-tour="form-bloque2">
            <BooleanInputs />
            <NumberInput
              source="availableAfterHours"
              placeholder="horas"
              label="Tiempo de reserva anticipada (horas)"
              validate={[required("Tiempo de reserva es requerido")]}
              defaultValue={24}
            />
            <NumberInput
              source="commissionEmployee"
              label="Comisión de Empleado (%)"
              placeholder="%"
              defaultValue={0}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }} data-tour="form-bloque3">
            <SelectInputCategory />
            <SelectInput
              validate={[required("El tiempo estimado es requerido")]}
              source="unitEstimatedWorkMinutes"
              label="Tiempo de servicio estimado"
              choices={choices}
              data-cy="service-time"
            />
            <SelectInput
              validate={[required("El método es requerido")]}
              source="method"
              label="Método"
              choices={[
                { id: "En sucursal", name: "En sucursal" },
                { id: "A domicilio", name: "A domicilio" },
                { id: "Ambos", name: "Ambos" },
              ]}
              data-cy="service-method"
            />
            {/* <NumberInput
          source="commissionEmployee"
          label="Comisión de Empleado (%)"
          placeholder="%" /> */}
            <TextInput
              source="provider._id"
              defaultValue={JSON.parse(localStorage.getItem("profile"))._id}
              disabled
              style={{ display: "none" }}
            />
            <TextInput
              source="provider.name"
              defaultValue={JSON.parse(localStorage.getItem("profile")).first_name}
              disabled
              style={{ display: "none" }}
            />
            <TextInput
              source="provider.logoURL"
              defaultValue={JSON.parse(localStorage.getItem("profile")).picture}
              disabled
              style={{ display: "none" }}
            />
            <PinnedInputs />
            {provider?.reminderConfirmed && (
              <NumberInput source="reminderIntervalDays" label="Tiempo del recordatorio en días" defaultValue={0} />
            )}
          </div>
        </SimpleForm>
      </StyledBaseCreate>
    </>
  );
};
